<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitted">

      <div ref="myTextarea" class="form-group">
        <label for="ppData">Полные данные платежки</label>
        <textarea readonly
            id="ppData"
            v-model="formatSber"
            rows="20"
            cols="100"
            class="form-control form-control-sm"
        />
      </div>

      <div @click="copyToClipboard" class="btn btn-sm btn-secondary">
        <i class="fas fa-ticket"></i> Скопировать в буфер
      </div>
      <p v-if="copyStatus">{{ copyStatus }}</p>

    </form>
  </div>

</template>

<script>

import {renderOnePaymentOrderHeaderForSber} from './partner_utils.js';
import { renderOnePaymentOrderBodyForSber } from './partner_utils.js';
import { renderOnePaymentOrderFooterUniversal } from './partner_utils.js';

export default {
  name: "ViewPartnerProfitOrder",
  data() {
    return {
      ppData: null,
      copyStatus: '',
      ppDataObject: {
        payer_current_account: null,
        number: null,
        date: null,
        sum: null,
        payer_inn: null,
        payer_name: null,
        payer_bank_name: null,
        payer_bank_city: null,
        payer_bank_bic: null,
        payer_bank_corr_account: null,
        recipient_current_account: null,
        recipient_inn: null,
        recipient_name: null,
        recipient_bank_name: null,
        recipient_bank_bic: null,
        recipient_bank_city: null,
        recipient_bank_corr_account: null,
        reason: null,
        reason_suffix: null,
        reason_suffix2: null,
      },
      submitted: false,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {
    formatSber(){
      return this.renderOneFor1c(this.ppDataObject);
    }
  },
  validations: {
  },
  methods: {
    renderOneFor1c(data) {
      return renderOnePaymentOrderHeaderForSber(data) + `\n`
          + renderOnePaymentOrderBodyForSber(data) + `\n`
          + renderOnePaymentOrderFooterUniversal()
          ;
    },
    setNullFormData() {
      this.ppData = null;
      this.copyStatus = '';
      this.ppDataObject = {
          payer_current_account: null,
          number: null,
          date: null,
          sum: null,
          payer_inn: null,
          payer_name: null,
          payer_bank_name: null,
          payer_bank_city: null,
          payer_bank_bic: null,
          payer_bank_corr_account: null,
          recipient_current_account: null,
          recipient_inn: null,
          recipient_name: null,
          recipient_bank_name: null,
          recipient_bank_bic: null,
          recipient_bank_city: null,
          recipient_bank_corr_account: null,
          reason: null,
          reason_suffix: null,
          reason_suffix2: null,
      };
    },
    async copyToClipboard() {
      try {
        // Использование Clipboard API
        await navigator.clipboard.writeText(this.formatSber);
        this.copyStatus = 'Текст скопирован!';
      } catch (err) {
        this.copyStatus = 'Ошибка при копировании';
        console.error('Ошибка:', err);
      }
    }
  },

};
</script>

<style scoped lang="css">

</style>
